// api/receivablePdf.api.ts

import apiHandler from "../core/apiHandler";


/**
 * 📄 API base para exportación PDF
 * de cuentas por cobrar
 *
 * Endpoint:
 * /api/pdf/receivables
 */
const receivablePdfApi = apiHandler("pdf/receivables");

export default receivablePdfApi;